module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_SCC.4db15099.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_SCC.png
// module id = 61
// module chunks = 0